// extracted by mini-css-extract-plugin
module.exports = {"footer":"rQbOeZ19P0gkrCsEuHoChA=="};